/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { TenantAccessPlan } from './TenantAccessPlan';
const TenantAccessPlanWithRefundDataParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['isRepurchase', codecBoolean, 'is_repurchase'],
]), TenantAccessPlan);
export class TenantAccessPlanWithRefundData extends TenantAccessPlan {
    static decode(input) {
        return TenantAccessPlanWithRefundDataParser.decode(input).map(res => new TenantAccessPlanWithRefundData(res));
    }
    static unsafeDecode(input) {
        return TenantAccessPlanWithRefundData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TenantAccessPlanWithRefundDataParser.encode(data);
    }
    static schema() {
        return TenantAccessPlanWithRefundDataParser.schema();
    }
}
